<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection></MetaSection>
      </GridCol>
      <GridCol :size="12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="12">
                <div class="d-flex align-items-center justify-content-start gap-2">
                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="getData(params.keyword)" type="text" class="form-control" placeholder="Cari nama pegawai..." style="border-right: 1px solid #d2d6da!important;"/>
                  </InputGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.periode_id"
                      :list="list_periode.map((item) => {
                        return {
                          value: item.id,
                          text: item.name,
                        };
                      })"
                      option-value="value"
                      option-text="text"
                      placeholder="Pilih Periode"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.unitkerja_id"
                      :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Semua Unit Kerja"
                    />
                  </FormGroup>

                  <!-- <FormGroup class="m-0 w-100">
                    <select @change="getData()" name="status" id="status" class="form-control" v-model="params.status">
                      <option value="">Semua Status</option>
                      <option value="1">Aktif</option>
                      <option value="0">Non Aktif</option>
                    </select>
                  </FormGroup> -->
                </div>
              </GridCol>
            </GridRow>
          </template>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">NIP</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Nama</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Unit Kerja</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Jabatan</th>
                  <!-- <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Posisi</th> -->
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Periode</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Status</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="data.length === 0">
                  <td :colspan="7" class="text-center p-4">Data tidak ditemukan</td>
                </tr>
                <tr v-for="(item, index) in data" :key="index">
                  <td>{{ item?.nip || '-' }}</td>
                  <td class="font-weight-bold">{{ item?.name || '-' }}</td>
                  <td>{{ item?.unitkerja || '-' }}</td>
                  <td>{{ item?.jabatan || '-' }}</td>
                  <td>{{ item?.periode || '-' }}</td>
                  <!-- <td>Posisi</td> -->
                  <td>
                    <argon-badge v-if="item.status == 'submission'" color="info">{{ item.status }}</argon-badge>
                    <argon-badge v-if="item.status == 'approved'" color="success">{{ item.status }}</argon-badge>
                    <argon-badge v-if="item.status == 'rejected'" color="danger">Non Aktif</argon-badge>
                  </td>
                  <td class="align-top">
                    <ThreeDotsMenu>
                      <router-link :to="{ name: 'Detail Usulan Kpi', params: { employee_id: item?.id, periode_id: item?.periode_id } }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Edit user">Detail</router-link>
                      <!-- <button @click.prevent="deleteData(item.id)"
                        class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                        data-original-title="Delete user">Hapus</button> -->
                    </ThreeDotsMenu>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ArgonPagination :page="params.page" :total_page="metaData.total_page" :current_page="metaData.current_page" @changepage="changePage" @changelimit="changeLimit" />
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import ArgonBadge from '@/components/ArgonBadge.vue';
// import ArgonButton from '@/components/ArgonButton.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import FormGroup from '@/components/FormGroup.vue';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';

import KpiPeriodeApi from '@/repository/api/KpiPeriodeApi';
import KpiUsulanApi from '@/repository/api/KpiUsulanApi';
import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
import ArgonPagination from '@/components/ArgonPagination.vue';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "tables",
  components: {
    // ArgonButton,
    CardComponent,
    InputGroup,
    ArgonBadge,
    ThreeDotsMenu,
    FormGroup,
    MetaSection,
    GridRow,
    GridCol,
    ArgonPagination,
    ModelListSelect,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      metaData: {},
      unitkerja: [],
      list_periode: [],
      params: {
        limit: "",
        status: "",
        unitkerja_id: "",
        keyword: "",
        page: 1,
        periode_id: '',
      },
    };
  },
  async mounted() {
    await this.getData();
    await this.getKpiPeriode();
    await this.getUnitKerja();
  },
  watch: {
    'params.unitkerja_id': {
      handler: async function () {
        this.getData();
      }
    },
    'params.periode_id': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
  },
  methods: {
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    async getKpiPeriode() {
      await KpiPeriodeApi.getbyparam({
        status: 'active',
        page: 'all',
      })
        .then((response) => {
          this.list_periode = response?.data || [];
          // this.params.periode_id = response?.data?.[0]?.id || '';
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getUnitKerja() {
      await UnitKerjaApi.getbyparam({page: 'all', status: "active"}).then((response) => {
        this.unitkerja = response.data;
      }).catch(() => {
        this.unitkerja = [];
      });
    },
    async getData(keyword = "") {
      clearTimeout(this.timer)
      if (keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          await this.getDataAll();
        }, 1500)
      }
    },
    async getDataAll() {
      let params = {}
      Object.keys(this.params).forEach(key => {
        if (!(this.params[key] === undefined || this.params[key] === null || this.params[key] === "")) {
          params[key] = JSON.parse(JSON.stringify(this.params[key]))
        }
      });
      await KpiUsulanApi.getbyparam(params)
        .then((resp) => {
          // console.log('resp', resp)
          this.data = resp?.data;

          this.metaData = {
            status: resp?.status ?? null,
            message: resp?.message ?? null,
            total_item: resp?.total_item ?? null,
            per_page: resp?.per_page ?? null,
            total_page: resp?.total_page ?? null,
            current_page: resp?.current_page ?? null,
          };
        }).catch(() => {
          this.metaData = {};
          this.data = [];
        });
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await KpiUsulanApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
            });
          });
        }
      })
    }
  },
};
</script>
